import list0 from '../assets/list/list0.jpg'
import list1 from '../assets/list/list1.jpg'
import list2 from '../assets/list/list2.jpg'
import list3 from '../assets/list/list3.jpg'
import list4 from '../assets/list/list4.jpg'
import list5 from '../assets/list/list5.jpg'
import list6 from '../assets/list/list6.jpeg'
import list7 from '../assets/list/list7.jpeg'
import list8 from '../assets/list/list8.jpeg'

export default [
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol001/',
    src: list0,
    title: '【全文】我們不是神：看不見的社工職業創傷',
    desc: '社工是一群專業的助人工作者，為何飽受社會大眾的誤解？他們面對社會最悲劇的陰暗角落，為何成了憂鬱沮喪的專業人士？《鏡週刊》人物組採用台北市社工師⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol002',
    src: list1,
    title: '【我們不是神1】社會安全網破洞很大　近8成社工憂鬱悲傷沮喪',
    desc: '西門町的戲院前，年輕社工剛買好電影票，就收到個案阿 B 傳來的自殺照片，一把水果刀血淋淋插在手腕上，「他不說在哪，只看得出來在超商，我跑遍大街小巷⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol003',
    src: list2,
    title: '【我們不是神2】血淋淋家暴個案成噩夢　社工得恐慌症一身都是病',
    desc: '巫馥彤對周遭變得沒耐心，不想跟路人、家人說話，「只把全身精力放在個案身上」。有好一陣子，她犧牲休息時間，只為了陪阿B聊天，走過他的憂鬱低潮⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol004',
    src: list3,
    title: '【我們不是神3】社會體制問題難反映　社工倫理界線成個人難題',
    desc: '我們走進政大校園，採訪社工所博士班的楊蕙如，她說：「社工有倫理守則，那是不能踩的底線，但實務上很複雜，你和個案的生活融合到什麼程度，才覺得⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol005',
    src: list4,
    title: '【我們不是神4】大家庭裡的媳婦　社工情緒壓力多來自政府官僚',
    desc: '有次郭可盼半夜接到電話，個案準備跳樓，「我立刻去他家，找他喝飲料，那個 moment 過去，他被壓垮的時刻就過了。我當然不希望他死，但我覺得人不是⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol006',
    src: list5,
    title: '【我們不是神5】社工單打獨鬥難紓壓　連心理創傷都不易察覺',
    desc: '今年 3 月，發生男童被繼父活活打死的事件，新聞底下有不少留言罵：「社工在幹嘛？」「高風險家庭為何不及早安置？」琪琪忍不住說：「社會大眾對社工⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol007',
    src: list6,
    title: '【我們不是神番外篇1】我們為什麼做社工？',
    desc: '社工郭可盼回憶起一段難以啟口的往事。她國中時，由於學校升學氛圍重，只注重成績，讓學生壓力很大，她當時發現有 1/4 的同學，手上都有割痕，「我也自傷過⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol008',
    src: list7,
    title: '【我們不是神番外篇2】我心中最痛苦與最值得的一件事',
    desc: '政大社工所博士生楊蕙如說了兩個故事。「十多年前，發生寄養家庭孩童相約集體逃亡的事件，其中一個女孩從小被安置，不僅狀況穩定，也幾乎把寄養爸媽⋯⋯'
  },
  {
    link: 'https://www.mirrormedia.mg/story/20200424pol009',
    src: list8,
    title: '【我們不是神番外篇3】社工是流動率最高的專業團體',
    desc: '「所有社工應該在每個階段，都有想離開的念頭。」就讀政大社工所博士班的楊蕙如這樣說：「在這行業要待夠久，只有 2 種可能，一個是夠麻木，一個是腦袋⋯⋯'
  }
]
